<template>
  <div class="evaluationreport">
    <el-form
      :inline="true"
      :model="dataForm"
      @keyup.enter.native.prevent="enterSearchMember(dataForm)"
      class="demo-form-inline toolbar"
      style="padding-bottom: 0px;"
    >
      <el-form-item label="统计日期">
        <el-date-picker
          :editable="false"
          v-model=" dataForm.dateTime"
          unlink-panels
          type="datetimerange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions"
          style="width:100%;margin-right:23px;"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click.native.prevent="channelOnSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <el-row>
      <h3 class="evaluationreport-h3">统计报表</h3>
      <el-table
        border
        :data="tableDataOne"
        highlight-current-row
        style="width: 100%;"
        :row-style="tableRowStyle"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column
          prop="serviceName"
          label="服务类别"
          min-width="200"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="orderNumber"
          label="订单数量"
          min-width="200"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="total"
          label="订单金额(元)"
          min-width="200"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <ul class="evaluationreport-ul ul-three clearfix">
        <li>
          <div id="chartPieOne" ref="chartPieOne" style="width:100%; height:350px"></div>
        </li>
        <li>
          <div id="chartPieTwo" ref="chartPieTwo" style="width:100%; height:350px"></div>
        </li>
      </ul>
    </el-row>
  </div>
</template>
<script>
import echarts from "echarts";
export default {
  data() {
    return {
      dataForm: {
        dateTime: []
      },
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() > Date.now();
        }
      },
      tableDataOne: [], //服务类别统计数据
      //服务类别统计的数据源
      serviceName: [],
      serviceNumber: [],
      servicePrice: [],
      numberColor:[
        "#c23531",
        "#2f4554",
        "#61a0a8",
        "#d48265",
        "#91c7ae",
        "#a94442",
        "#3c763d",
        "#a9334c"
      ],
      totalColor:[
        "#c23531",
        "#2f4554",
        "#61a0a8",
        "#d48265",
        "#91c7ae",
        "#a94442",
        "#3c763d",
        "#a9334c"
      ],
      groupId: "",
      merchantId:"",
    };
  },
  methods: {
    /* 
      键盘事件 按下键盘回车 查询
    */
    enterSearchMember() {
      this.drawCharts();
    },

    /* 
      查询
    */
    channelOnSubmit() {
      this.drawCharts();
    },

    /* 
      获取商家id
    */
    queryMerchantId() {
      this.$postJson("uac/merchant/haveId").then(res => {
        console.log(res, "查询商家id");
        this.merchantId = res.result;
        this.queryServiceItem();
      });
    },

    /* 
      查询服务类别的数量和金额
    */
    queryServiceItem() {
      let params = new Object();
      params.groupId = this.groupId;
      if (this.dataForm.dateTime && this.dataForm.dateTime.length > 0) {
        params.startTime = this.dataForm.dateTime[0];
        params.endTime = this.dataForm.dateTime[1];
      }
      params.merchantId = this.merchantId; //商家id
      console.log(params);
      this.$postJson("omc/serviceOrder/orderCount", params).then(res => {
        console.log(res, "查询数据");
        this.tableDataOne = [];
        this.serviceName = [];
        this.serviceNumber = [];
        this.servicePrice = [];
        // this.numberColor=[];
        // this.totalColor=[];
        let dataObj = {
          serviceFirstLevelId: "",
          total: 0,
          orderNumber: 0,
          serviceName: "合计"
        };
        res.result.forEach(item => {
          if(item.serviceSecondLevelId){
            this.serviceName.push(item.serviceName);
            let NumberObj = {};
            let totalObj = {};
            NumberObj.value = item.orderNumber;
            NumberObj.name = item.serviceName;
            totalObj.value = item.total;
            totalObj.name = item.serviceName;
            this.serviceNumber.push(NumberObj);
            this.servicePrice.push(totalObj);
            dataObj.total += item.total * 1;
            dataObj.orderNumber += item.orderNumber * 1;
            this.tableDataOne.push(item)
          }
        });
        this.tableDataOne.push(dataObj);
        this.drawPieOneChart();
        this.drawPieTwoChart();
      });
    },

    /* 
      数量占比
    */
    drawPieOneChart() {
      var myChartPie = this.$refs.chartPieOne;
      if (myChartPie) {
        let chartPie = echarts.init(myChartPie);
        chartPie.setOption({
          title: {
            text: "数量占比",
            subtext: "",
            x: "center"
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          color: this.numberColor,
          legend: {
            // orient: "vertical",
            // top:"bottom",
            bottom: 0,
            left: "center",
            data: this.serviceName
          },
          series: [
            {
              name: "数量占比分析",
              type: "pie",
              radius: "80%",
              center: ["50%", "50%"],
              clickable:false,　　　　　　 //是否开启点击
              minAngle: 20,           　　 //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
              avoidLabelOverlap: true,   //是否启用防止标签重叠策略
              hoverAnimation:true,　　  //是否开启 hover 在扇区上的放大动画效果。
              silent: false,　　　　　　　　//图形是否不响应和触发鼠标事件
              data: this.serviceNumber,//数据源
              label: {
                normal: {
                  formatter: "{b}",
                  textStyle: {
                    fontSize: 12
                    // color: "#fff"
                  }
                }
              }
            }
          ]
        });
      }
    },

    /* 
      金额占比
    */
    drawPieTwoChart() {
      var myChartPie = this.$refs.chartPieTwo;
      if (myChartPie) {
        let chartPie = echarts.init(myChartPie);
        chartPie.setOption({
          title: {
            text: "金额占比",
            subtext: "",
            x: "center"
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          color: this.totalColor,
          legend: {
            // orient: "vertical",
            // top:"bottom",
            left: "center",
            bottom: 0,
            data: this.serviceName
          },
          series: [
            {
              name: "金额占比分析",
              type: "pie",
              radius: "80%",
              center: ["50%", "50%"],
              clickable:false,　　　　　　 //是否开启点击
              minAngle: 20,           　　 //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
              avoidLabelOverlap: true,   //是否启用防止标签重叠策略
              hoverAnimation:true,　　  //是否开启 hover 在扇区上的放大动画效果。
              silent: false,　　　　　　　　//图形是否不响应和触发鼠标事件
              data: this.servicePrice,//数据源
              label: {
                normal: {
                  formatter: "{b}",
                  textStyle: {
                    fontSize: 12
                    // color: "#fff"
                  }
                }
              }
            }
          ]
        });
      }
    },

    /* 
      画图
    */
    drawCharts() {
      this.$nextTick(() => {
        this.queryMerchantId();
      });
    },

    /* 
      修改table tr行的背景色
    */
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #e4f5f8";
      } else {
        return "background-color: #f9f9f9";
      }
    },

    /* 
      修改table header的背景色
    */
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#bee1f4;color:#6f7075;font-weight: 500;";
      }
    }
  },
  computed: {},
  components: {},
  created() {
    this.groupId = sessionStorage.getItem("groupId");
  },
  mounted() {
    this.drawCharts();
  }
};
</script>
<style lang="scss" scoped>
.evaluationreport {
  .evaluationreport-h3 {
    text-align: center;
    margin: 10px auto;
    font-weight: 700;
    color: rgb(59, 56, 56);
  }
  .ul-one {
    border: 1px solid #ccc;
    border-right: none;
  }
  .ul-two {
    border: 1px solid #ccc;
    border-top: none;
    border-right: none;
  }
  .evaluationreport-ul {
    color: rgb(70, 67, 67);
  }
  .evaluationreport-ul li {
    float: left;
    width: 10%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    list-style: none;
    box-sizing: border-box;
  }
  .ul-one li:nth-child(2n) {
    border-right: 1px solid #ccc;
  }
  .ul-one li:nth-child(2n + 1) {
    background: #bee1f4;
    border-right: 1px solid #ccc;
  }
  .ul-two li:nth-child(2n) {
    border-right: 1px solid #ccc;
  }
  .ul-two li:nth-child(2n + 1) {
    background: #bee1f4;
    border-right: 1px solid #ccc;
  }
  .ul-three {
    height: 100%;
    border: 1px solid #ccc;
    border-top: none;
    border-right: none;
  }
  .ul-three li {
    width: 50%;
    height: 100%;
    border-right: 1px solid #ccc;
  }
}
</style>